import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Eagerly load all *_controller.js files in this directory tree.
// This replaces the deprecated stimulus/webpack-helpers approach.
const context = require.context("controllers", true, /_controller\.js$/);
context.keys().forEach((key) => {
  const module = context(key);
  const name = key
    .replace(/^\.\//, "")
    .replace(/_controller\.js$/, "")
    .replace(/_/g, "-")
    .replace(/\//g, "--");
  application.register(name, module.default);
});
